/**
 * Facultades y carreras de ESPOL. En `shared` porque el cliente dibuja los
 * desplegables con esta lista y el servidor valida contra ella.
 *
 * Tomado de la oferta académica oficial el 2026-08-16:
 * https://www.espol.edu.ec/es/admision/oferta-academica
 *
 * Los nombres se corrigen libremente; los ids están guardados en la base y
 * cambiarlos exige migrar esas filas.
 */
export const FACULTIES = [
    {
        id: "fadcom",
        code: "FADCOM",
        name: "Arte, Diseño y Comunicación Audiovisual",
        programs: [
            { id: "fadcom-animacion", name: "Animación Digital y Videojuegos" },
            { id: "fadcom-productos", name: "Diseño de Productos" },
            { id: "fadcom-grafico", name: "Diseño Gráfico" },
            { id: "fadcom-audiovisual", name: "Producción para Medios de Comunicación" },
        ],
    },
    {
        id: "fcnm",
        code: "FCNM",
        name: "Ciencias Naturales y Matemáticas",
        programs: [
            { id: "fcnm-estadistica", name: "Estadística" },
            { id: "fcnm-quimica", name: "Ingeniería Química" },
            { id: "fcnm-logistica", name: "Logística y Transporte" },
            { id: "fcnm-matematica", name: "Matemática" },
        ],
    },
    {
        id: "fcsh",
        code: "FCSH",
        name: "Ciencias Sociales y Humanísticas",
        programs: [
            { id: "fcsh-administracion", name: "Administración de Empresas" },
            { id: "fcsh-arqueologia", name: "Arqueología" },
            { id: "fcsh-auditoria", name: "Auditoría y Control de Gestión" },
            { id: "fcsh-economia", name: "Economía" },
            { id: "fcsh-turismo", name: "Turismo" },
        ],
    },
    {
        id: "fcv",
        code: "FCV",
        name: "Ciencias de la Vida",
        programs: [
            { id: "fcv-biologia", name: "Biología" },
            { id: "fcv-agricola", name: "Ingeniería Agrícola y Biológica" },
        ],
    },
    {
        id: "fict",
        code: "FICT",
        name: "Ingeniería en Ciencias de la Tierra",
        programs: [
            { id: "fict-geologia", name: "Geología" },
            { id: "fict-civil", name: "Ingeniería Civil" },
            { id: "fict-minas", name: "Minas" },
            { id: "fict-petroleos", name: "Petróleos" },
        ],
    },
    {
        id: "fiec",
        code: "FIEC",
        name: "Ingeniería en Electricidad y Computación",
        programs: [
            // La oferta la marca "(Híbrido)", que es la modalidad y no parte del nombre.
            { id: "fiec-datos", name: "Ciencia de Datos e Inteligencia Artificial" },
            { id: "fiec-computacion", name: "Computación" },
            { id: "fiec-electricidad", name: "Electricidad" },
            { id: "fiec-electronica", name: "Electrónica y Automatización" },
            { id: "fiec-telecomunicaciones", name: "Telecomunicaciones" },
            { id: "fiec-telematica", name: "Telemática" },
        ],
    },
    {
        id: "fimcm",
        code: "FIMCM",
        name: "Ingeniería Marítima y Ciencias del Mar",
        programs: [
            { id: "fimcm-acuicultura", name: "Acuicultura" },
            { id: "fimcm-naval", name: "Ingeniería Naval" },
            { id: "fimcm-oceanografia", name: "Oceanografía" },
        ],
    },
    {
        id: "fimcp",
        code: "FIMCP",
        name: "Ingeniería en Mecánica y Ciencias de la Producción",
        programs: [
            { id: "fimcp-alimentos", name: "Alimentos" },
            { id: "fimcp-industrial", name: "Ingeniería Industrial" },
            { id: "fimcp-materiales", name: "Materiales" },
            { id: "fimcp-mecanica", name: "Mecánica" },
            { id: "fimcp-mecatronica", name: "Mecatrónica" },
        ],
    },
];
/** La malla de ESPOL llega a décimo; más allá de eso ya no es un semestre. */
export const MIN_SEMESTER = 1;
export const MAX_SEMESTER = 10;
export function getFaculty(id) {
    if (typeof id !== "string")
        return null;
    return FACULTIES.find((faculty) => faculty.id === id) ?? null;
}
/** Se busca dentro de la facultad: así no se puede guardar "FIEC + Arqueología". */
export function getProgram(facultyId, programId) {
    const faculty = getFaculty(facultyId);
    if (!faculty || typeof programId !== "string")
        return null;
    return faculty.programs.find((program) => program.id === programId) ?? null;
}
export function isSemester(value) {
    return (typeof value === "number" &&
        Number.isInteger(value) &&
        value >= MIN_SEMESTER &&
        value <= MAX_SEMESTER);
}
//# sourceMappingURL=academics.js.map